<template>
  <section class="home-section">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          <span class="highlight">AutoSquare</span> <br />
          探索地质工程的未来
        </h1>
        <p class="hero-subtitle">
          我们专注于研发最前沿的地质工程专业软件，利用数字化和智能化技术，为复杂的工程问题提供精准、高效的解决方案。
        </p>
        <div class="hero-actions">
          <button class="btn btn-primary" @click="scrollToProducts">了解我们的产品</button>
          <button class="btn btn-outline" @click="scrollToAbout">了解团队</button>
        </div>
      </div>
      <div class="hero-visual">
        <div class="tech-shape">
          <div class="cube cube-1"></div>
          <div class="cube cube-2"></div>
          <div class="cube cube-3"></div>
        </div>
      </div>
    </div>

    <div class="scroll-indicator">
      <div class="mouse">
        <div class="wheel"></div>
      </div>
      <span>向下滚动</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeSection',
  methods: {
    scrollToProducts() {
      document.getElementById('products').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToAbout() {
      document.getElementById('about').scrollIntoView({ behavior: 'smooth' });
    }
  }
}
</script>

<style scoped>
.home-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(var(--nav-height) + 2rem) 5% 4rem;
  overflow: hidden;
  background: radial-gradient(circle at 80% 20%, rgba(37, 99, 235, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 20% 80%, rgba(6, 182, 212, 0.05) 0%, transparent 40%);
}

.hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  gap: 4rem;
  z-index: 2;
}

.hero-text {
  flex: 1;
  max-width: 600px;
  animation: slideUp 1s cubic-bezier(0.1, 0.8, 0.2, 1) forwards;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  color: var(--text-primary);
  letter-spacing: -1px;
}

.highlight {
  color: var(--accent-color);
  background: linear-gradient(135deg, #2563eb 0%, #06b6d4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: var(--text-secondary);
  margin-bottom: 2.5rem;
  line-height: 1.8;
}

.hero-actions {
  display: flex;
  gap: 1.5rem;
}

.btn {
  padding: 0.8rem 2rem;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-family: inherit;
}

.btn-primary {
  background-color: var(--accent-color);
  color: white;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
}

.btn-primary:hover {
  background-color: var(--accent-hover);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  color: var(--text-primary);
  border: 1px solid rgba(15, 23, 42, 0.15);
}

.btn-outline:hover {
  border-color: var(--accent-color);
  color: var(--accent-color);
  background: rgba(37, 99, 235, 0.05);
}

.hero-visual {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px;
}

.tech-shape {
  position: relative;
  width: 400px;
  height: 400px;
  transform-style: preserve-3d;
  animation: float 10s ease-in-out infinite;
}

.cube {
  position: absolute;
  border: 2px solid rgba(37, 99, 235, 0.15);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
}

.cube-1 {
  width: 250px;
  height: 250px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(45deg) rotateZ(45deg);
  box-shadow: 0 10px 40px rgba(37, 99, 235, 0.1);
}

.cube-2 {
  width: 300px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(60deg) rotateZ(20deg);
  border-color: rgba(6, 182, 212, 0.15);
}

.cube-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(30deg) rotateZ(75deg);
  border-color: rgba(99, 102, 241, 0.2);
}

.scroll-indicator {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary);
  font-size: 0.85rem;
  letter-spacing: 1px;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.scroll-indicator:hover {
  opacity: 1;
}

.mouse {
  width: 24px;
  height: 36px;
  border: 2px solid var(--text-secondary);
  border-radius: 12px;
  position: relative;
}

.wheel {
  width: 4px;
  height: 6px;
  background-color: var(--text-secondary);
  border-radius: 2px;
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  animation: scrollWheel 2s infinite;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0) rotateX(0deg) rotateY(0deg);
  }

  50% {
    transform: translateY(-20px) rotateX(10deg) rotateY(-10deg);
  }
}

@keyframes scrollWheel {
  0% {
    transform: translate(-50%, 0);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, 15px);
    opacity: 0;
  }
}

@media (max-width: 992px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
    margin-top: 4rem;
  }

  .hero-title {
    font-size: 2.8rem;
  }

  .hero-actions {
    justify-content: center;
  }

  .hero-visual {
    margin-top: 2rem;
  }

  .tech-shape {
    width: 300px;
    height: 300px;
  }
}

@media (max-width: 768px) {
  .home-section {
    padding: calc(var(--nav-height) + 1rem) 1rem 3rem;
  }

  .hero-content {
    margin-top: 2rem;
    gap: 2rem;
  }

  .hero-title {
    font-size: 2.2rem;
    margin-bottom: 1rem;
  }

  .hero-subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .hero-actions {
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .btn {
    width: 100%;
  }

  .tech-shape {
    width: 250px;
    height: 250px;
  }

  .cube-1 {
    width: 150px;
    height: 150px;
  }

  .cube-2 {
    width: 180px;
    height: 180px;
  }

  .cube-3 {
    width: 120px;
    height: 120px;
  }
}
</style>
